import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Select } from '@components/antd';
import { historyType } from '@propTypes';
import { useListingSearchCriteria } from '../../utils';
import s from './SortDropdown.module.less';

const SortDropdown = ({ sort, history, disabled, sortChanged }) => {
  const { t } = useTranslation('listingSearch');

  const criteria = useListingSearchCriteria();

  const onSortByClick = value => {
    sortChanged(value);
    criteria.add('sort', value);
    criteria.add('page', 1);

    history.push(criteria.toUrl());
  };

  return (
    <div className={s.searchSort}>
      <div className={s.sortByText}>{t('sortBy')}</div>
      <Select
        onSelect={onSortByClick}
        disabled={disabled}
        value={sort}
        className={s.select}
        dropdownAlign={{
          points: ['tr', 'br'],
          offset: [0, 8],
          overflow: {
            adjustX: 0,
            adjustY: 1,
          },
        }}
        data-testid="search-sort-select"
        dropdownClass={s.selectDropdown}
      >
        <Select.Option value="newest">{t('sortingOptions.newest')}</Select.Option>
        <Select.Option value="largest">{t('sortingOptions.largest')}</Select.Option>
        <Select.Option value="smallest">{t('sortingOptions.smallest')}</Select.Option>
        <Select.Option value="available_soonest">
          {t('sortingOptions.availableSoonest')}
        </Select.Option>
        <Select.Option value="available_latest">
          {t('sortingOptions.availableLatest')}
        </Select.Option>
      </Select>
    </div>
  );
};

SortDropdown.defaultProps = {
  sort: '',
  disabled: false,
};

SortDropdown.propTypes = {
  history: historyType.isRequired,
  sort: PropTypes.oneOf(['newest', 'largest', 'smallest', 'available_soonest', 'available_latest']),
  disabled: PropTypes.bool,
  sortChanged: PropTypes.func.isRequired,
};

export default withRouter(SortDropdown);
